import { render, staticRenderFns } from "./MaintenancePage.vue?vue&type=template&id=09bffd43&scoped=true"
import script from "./MaintenancePage.vue?vue&type=script&lang=js"
export * from "./MaintenancePage.vue?vue&type=script&lang=js"
import style0 from "./MaintenancePage.vue?vue&type=style&index=0&id=09bffd43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bffd43",
  null
  
)

export default component.exports